import { useEffect, useState } from "react";

// use global variables
let isGeneratingHazards = false;
let observers = [];

// changes global state and updates all observers
export const setIsGeneratingHazards = (generatingHazards) => {
  isGeneratingHazards = generatingHazards;
  observers.forEach((update) => update(isGeneratingHazards));
};

// React Hook
export const useHazardGenerator = () => {
  const [isGeneratingHazardsState, setIsGeneratingHazardsState] =
    useState(isGeneratingHazards);

  useEffect(() => {
    // add to observers list
    observers.push(setIsGeneratingHazardsState);

    // update with latest global state
    setIsGeneratingHazardsState(isGeneratingHazards);

    // remove from observers, when component unmounts
    return () => {
      observers = observers.filter(
        (update) => update !== setIsGeneratingHazardsState
      );
    };
  }, []);

  // return global state and setter function
  return [isGeneratingHazardsState, setIsGeneratingHazards];
};
